import { render, staticRenderFns } from "./DeviceInfoEnvolventePortas.vue?vue&type=template&id=6863a653&"
import script from "./DeviceInfoEnvolventePortas.vue?vue&type=script&lang=js&"
export * from "./DeviceInfoEnvolventePortas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports